<template>
    <v-container>
        <v-row>
            <default-text/>
            <default-images/>
        </v-row>
    </v-container>
</template>

<script>
import { mapState } from 'vuex';
import DefaultImages from './DefaultImages';
import DefaultText from './DefaultText';

export default {
    name: 'Introduction',
    components: { DefaultText, DefaultImages },
    mixins: [],
    props: {},
    data() {
        return {};
    },
    computed: {
        ...mapState('collectivite', ['collectivite']),
    },
    watch: {},
    created() {

    },
    methods: {},
}
</script>



// WEBPACK FOOTER //
// src/components/Simulateur/Introduction.vue